import React from 'react';
import Button from '../Button/Button';
import { FallbackWrapper, FallbackCard, FallbackActions } from './ErrorBoundary.styles';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    console.error('Error de interfaz capturado:', error, info?.componentStack);
  }

  render() {
    if (!this.state.hasError) return this.props.children;

    return (
      <FallbackWrapper role="alert">
        <FallbackCard>
          <a href="/" aria-label="BokerHub, ir al inicio">
            <img className="brand-logo" src="/assets/logos/logo-color.png" alt="BokerHub" />
          </a>
          <h1>Algo salió mal</h1>
          <p>
            Ocurrió un error inesperado al mostrar esta pantalla. Puedes
            recargar la página o volver al inicio.
          </p>
          <FallbackActions>
            <Button onClick={() => window.location.reload()}>Recargar</Button>
            <Button variant="secondary" onClick={() => window.location.assign('/')}>
              Ir al inicio
            </Button>
          </FallbackActions>
        </FallbackCard>
      </FallbackWrapper>
    );
  }
}

export default ErrorBoundary;
